/* eslint-disable */
import "core-js/es";
import "react-app-polyfill/ie11";

import "react-app-polyfill/stable";
import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import App from "./App";
import App1 from './App1';
// import App2 from './App2'
import {getSearchString} from "src/js/common/utils";
import * as serviceWorker from "./serviceWorker";
import store from './store/index'
import {Provider} from "react-redux";

let location = window.location;

ReactDOM.render(
  <Provider store={store}>
    <App1/>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
